import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getJackpotList = (params) => {
    return axios.get(`${backendHost}/api/admin/jackpot/list`, {params});
};

export {
    getJackpotList
}